import {
    FETCH_FEATURE_FLAGS_DATA,
    FETCH_FEATURE_FLAGS_DATA_SUCCESS,
    FETCH_FEATURE_FLAGS_DATA_FAILURE
} from "./types";
import { getResponseData } from "../../middleware/middleware";

export const fetchFeatureFlagsData = (isLoading) => {
  return {
    type: FETCH_FEATURE_FLAGS_DATA,
    isLoading
  };
};

export const fetchFeatureFlagsDataSuccess = (data, isLoading) => {
  return {
    type: FETCH_FEATURE_FLAGS_DATA_SUCCESS,
    data,
    isLoading,
  };
};

export const fetchFeatureFlagsDataFailure = (error, isLoading) => {
  return {
    type: FETCH_FEATURE_FLAGS_DATA_FAILURE,
    error,
    isLoading, 
  };
};

export const getFeatureFlagsData = () =>
  async (dispatch) => {
    dispatch(fetchFeatureFlagsData(true));
    const payload = {
      method: "GET",
      url: `/api/session/v1/featureFlags`
    };
    const getdata = await getResponseData(payload);
    if (getdata?.status ===  200 ) {
      dispatch(fetchFeatureFlagsDataSuccess(getdata.data, false ));
    } else {
      dispatch(fetchFeatureFlagsDataFailure({ statusCode: getdata?.status, message: getdata?.message, data: getdata?.response?.data }, false));
    }
  };